import { useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import FadeBox from "../../components/animate/FadeBox";
import Config from "../../config/config";
import usePageTitle from "../../hooks/use-page-title";
import ApiAuth from "../../modules/api/auth";
import Debouncer from "../../modules/debouncer/debouncer";
import Notifier from "../../modules/notifier/notifier";
import { ROUTES } from "../../routes";
import ModuleValidation from "../../modules/validation";
import FGToggleTextPassword from "../../components/dumb/FGToggleTextPassword";

export default function PageResetPassword() {
  usePageTitle("Reset Password");
  const { resetPasswordToken } = useParams();
  const [showSubmitted, setShowSubmitted] = useState(false);
  const [error, setError] = useState("");
  const refPassword = useRef<HTMLInputElement>();
  const refConfirmPassword = useRef<HTMLInputElement>();

  const handleOnSubmit = (e: any) => {
    e.preventDefault();

    if (Config.IS_MOCKUP_MODE) {
      return;
    }

    if (!resetPasswordToken) {
      return;
    }

    const password = refPassword.current.value;
    const confirmPassword = refConfirmPassword.current.value;
    const validate = ModuleValidation.isChangePasswordFormValid({
      newPassword: password,
      confirmNewPassword: confirmPassword
    });

    if (!validate.valid) {
      setError(validate.message);
      return;
    }

    Debouncer.execute("RESET_PASSWORD", async () => {
      const payload = {
        password,
        confirmPassword,
      };
      const req = await ApiAuth.resetPassword(resetPasswordToken, payload);

      if (req.status) {
        Notifier.success(req.message);
        refPassword.current.value = "";
        refConfirmPassword.current.value = "";
        setShowSubmitted(true);
      } else {
        Notifier.error(req.message);
      }
    });
  };

  return (
    <div className="PA__main">
      <FadeBox show={!showSubmitted}>
        <form className="form-default" onSubmit={handleOnSubmit}>
          <h1>Reset Password</h1>

          {error.trim().length > 0 && <p className="alert alert-danger">
            {error}
          </p>}

          <FGToggleTextPassword
            label="New Password"
            placeholder="Type your new password"
            autoFocus
            required
            inputRef={(ref) => refPassword.current = ref}
          />

          <FGToggleTextPassword
            label="Confirm New Password"
            placeholder="Retype your new password"
            required
            inputRef={(ref) => refConfirmPassword.current = ref}
          />

          <p className="text-center">
            <button type="submit" className="btn btn-secondary">
              Submit
            </button>
          </p>

          <p className="text-center mb-0">
            <Link to={ROUTES.AUTH_LOGIN} className="link-grey">Back</Link>
          </p>
        </form>
      </FadeBox>

      <FadeBox show={showSubmitted}>
        <div>
          <h1>Password Reset Success</h1>
          <p>Your password has been reset successfully.</p>
          <p className="text-center mb-0">
            <Link to={ROUTES.AUTH_LOGIN} className="btn btn-secondary">
              Click here to login
            </Link>
          </p>
        </div>
      </FadeBox>
    </div>
  );
}
